export const getManagersData = state => state.managers.all;
export const getManagerData = state => state.managers.manager;
export const managersIsFetching = state => state.managers.loading.all;
export const managerIsFetching = state => state.managers.loading.manager;